<template>
  <div class="DivisionTitle">{{ title }}</div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
  },
}
</script>

<style lang="scss" scoped>
.DivisionTitle {
  font-weight: bold;
  color: #1a1a1a;
  background-color: #eeeeee;
  padding: 14px 21px 14px 16px;
  margin-bottom: 15px;
}
</style>
